export const requestFullscreen = async () => {
  if (!document.fullscreenElement) {
    await document.documentElement.requestFullscreen?.();
  }
};

export const exitFullscreen = async () => {
  if (document.fullscreenElement) {
    await document.exitFullscreen?.();
  }
};
